// extracted by mini-css-extract-plugin
module.exports = {"root":"_de609b6","image":"_be981f9","text":"_a005931"};